import { ReactElement } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { BreakpointMedia } from 'config';
import { useMediaQuery } from 'react-responsive';
import DropdownWithIcon from '../shared/DropdownWithIcon';
import { MY_ACCOUNT_DROPDOWN_OPTIONS } from './utils/constants';
import ReactivationBanner from '../shared/banners/ReactivationBanner';
import useCurrentUser from '../../hooks/useCurrentUser';

function MyAccountLayout(): ReactElement {
  const navigate = useNavigate();
  const isNarrowScreen = !useMediaQuery({ query: BreakpointMedia.LG });
  const selectedDropdownOption = MY_ACCOUNT_DROPDOWN_OPTIONS.find(
    (option) => option.value === window.location.pathname,
  );
  const { currentUser } = useCurrentUser();

  return (
    <div className="col">
      <div className="c-profile c-my-account">
        <h1
          className={[
            'c-heading',
            'c-heading--center',
            'c-heading--brand-4',
          ].join(' ')}
        >
          My Account
        </h1>
        {currentUser.isDeactivated && <ReactivationBanner />}
        {isNarrowScreen && (
          <div className="c-my-account__dropdown">
            <DropdownWithIcon
                // @ts-expect-error TODO: fix null safety
              selectedOption={selectedDropdownOption}
              options={MY_ACCOUNT_DROPDOWN_OPTIONS}
              onSelect={(selectedOption) => {
                navigate(selectedOption.value);
              }}
            />
          </div>
        )}
        <Outlet />
      </div>
    </div>
  );
}

export default MyAccountLayout;
